module.exports = __webpack_public_path__ + "img/certificate_ogr_420301816_00.7b6e6404.png";